var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9974 0.166992C7.27323 0.166992 0.164062 7.27616 0.164062 16.0003C0.164062 24.7245 7.27323 31.8337 15.9974 31.8337C24.7216 31.8337 31.8307 24.7245 31.8307 16.0003C31.8307 7.27616 24.7216 0.166992 15.9974 0.166992ZM21.3174 19.642C21.7766 20.1012 21.7766 20.8612 21.3174 21.3203C21.0799 21.5578 20.7791 21.6687 20.4782 21.6687C20.1774 21.6687 19.8766 21.5578 19.6391 21.3203L15.9974 17.6787L12.3557 21.3203C12.1182 21.5578 11.8174 21.6687 11.5166 21.6687C11.2157 21.6687 10.9149 21.5578 10.6774 21.3203C10.2182 20.8612 10.2182 20.1012 10.6774 19.642L14.3191 16.0003L10.6774 12.3587C10.2182 11.8995 10.2182 11.1395 10.6774 10.6803C11.1366 10.2212 11.8966 10.2212 12.3557 10.6803L15.9974 14.322L19.6391 10.6803C20.0982 10.2212 20.8582 10.2212 21.3174 10.6803C21.7766 11.1395 21.7766 11.8995 21.3174 12.3587L17.6757 16.0003L21.3174 19.642Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBg);
export default __webpack_public_path__ + "static/media/CrossBG.a5f0fbc269663e9b502f53b3ffa34855.svg";
export { ForwardRef as ReactComponent };